import IntegrityButton from "./IntegrityButton";
import InsertImageButton from "./InsertImageButton";
import TextValueBar from "./TextValueBar";
import TableOutlineToggleButton from "./TableOutlineToggleButton";
import ExportButton from './ExportButton';
import G from './Getters';
import Tooltip from '@material-ui/core/Tooltip';
import CiteButton from './CiteButton';

//import * as htmlToImage from 'html-to-image';
//import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';



export default function ValueDisplay({
  tableOutlineShowing,
  setTableOutlineShowing,
  

  selectionJustMade,
  setSelectionJustMade,
  cellValueInputRef,
  //temporaryCellValue,

  //setTemporaryCellValue,
  setSvg,
  retainInputFocus,
  figurePanelId,

  //focusedOnValueDisplay,
  //setFocusedOnValueDisplay,
  focusedOnValueDisplayRef,

}){

  

  let actionToolbar = (
    <div class="sg-row v-center" style={{
      position:'absolute',
      left:'calc( max(25%, 200px) )',
      top:10,
      //transform:'translate(-50%,0)',
    }}>
      {false && <div style={{ border:'3px solid red', flexWidth:'25%', height:1 }}/>}

    <InsertImageButton/>
        <ExportButton {...{ 
          button:"top-export-button",
          key:figurePanelId, 
          setSvg, 
          figurePanelId 
          }}/>

      <IntegrityButton/>

        <CiteButton/>

        <TableOutlineToggleButton {...{tableOutlineShowing,setTableOutlineShowing}}/>

    </div>

  )

  

  return (
    <div style={{
      }} class="small-margin">
      <div class="sg-row v-center">

        <div style={{
          display:'flex',
          marginRight:5,
          alignItems:'center',
          //border:(focusedOnValueDisplayRef.current?"1px solid blue":null)
          
        }}></div>
        

          <div style={{position:'relative',display:'flex',alignItems:'center'}}>

            <Tooltip disableFocusListener title={"Multiple lines: Alt + Enter"}>
              {/*<GridValueEditor/>*/}
              <TextValueBar {...{
                selectionJustMade,
                setSelectionJustMade,
                cellValueInputRef,
                focusedOnValueDisplayRef,
                retainInputFocus,
                figurePanelId
              }}/> 
            </Tooltip>
        </div>

        {actionToolbar}

      </div>
    </div>
  )
}

